import React from 'react';
import styled from 'styled-components';
import { mt } from '@nib/layout';
import { Label } from '@nib-components/form-control';
import { FUNNELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const characterWidths = {
  2: '3.7475em',
  4: '6em'
};
const CustomLabel = styled(Label)`
  font-size: 0.875rem;
  font-weight: normal;
`;
const NestedInputWrapper = styled.div`
  display: inline-block;
  width: 100%;
  max-width: ${_ref => {
  let {
    width
  } = _ref;
  return characterWidths[width];
}};
  position: relative;
  ${mt(2)};
`;
NestedInputWrapper.displayName = 'NestedInputWrapper';
class NestedFormControl extends React.Component {
  constructor(props) {
    super(props);
    const {
      id = ''
    } = props;
    this.state = {
      id
    };
  }
  render() {
    const {
      children,
      className = '',
      disabled = false,
      id = '',
      error = '',
      help = '',
      name = '',
      valid = false,
      validated = false,
      label = FUNNELS.ARHI,
      width = 2,
      /* eslint-disable no-unused-vars */
      // redux-formo methods
      blur,
      change,
      filter,
      focus,
      initialise,
      validate,
      // redux-form props
      active,
      filtered,
      filtering,
      initialised,
      lastValidValue,
      validating,
      /* validated, */
      /* eslint-enable no-unused-vars */
      ...otherProps
    } = this.props;
    return (
      //@ts-ignore disabled not prop of html div element
      React.createElement("div", {
        disabled: disabled,
        className: className
      }, React.createElement(CustomLabel, {
        disabled: disabled,
        htmlFor: id
      }, label), React.createElement(NestedInputWrapper, {
        width: width
      }, children && React.cloneElement(children, {
        ...otherProps,
        valid,
        validated,
        disabled,
        id,
        name,
        error,
        help,
        label,
        'aria-describedby': `error-${id}`,
        'aria-invalid': !valid
      })))
    );
  }
}
NestedFormControl.displayName = '';
NestedFormControl.displayName = 'FormControl';
NestedFormControl.defaultProps = {
  ...defaultFieldPropTypes,
  width: 2
};
export default NestedFormControl;